/**
 * Live-canvas room ids and share links for DeskeyPaint / DeskeyChart.
 *
 * A room id is `<kind>-<random>`; the kind tells the standalone /live page
 * which canvas to open. The collab socket is unauthenticated, so the random
 * part comes from crypto and is long enough not to be guessable.
 */
const CANVAS_KINDS = ['paint', 'chart'];
const ROOM_ID_RANDOM_LENGTH = 16;
const ROOM_ID_PATTERN = /^(paint|chart)-[a-z0-9]{6,32}$/;
const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';

/** @param {'paint'|'chart'} kind */
export function newRoomId(kind) {
  if (!CANVAS_KINDS.includes(kind)) throw new Error(`Unknown canvas kind: ${kind}`);
  const bytes = window.crypto.getRandomValues(new Uint8Array(ROOM_ID_RANDOM_LENGTH));
  const random = Array.from(bytes, b => ALPHABET[b % ALPHABET.length]).join('');
  return `${kind}-${random}`;
}

/** @returns {boolean} */
export function isValidRoomId(roomId) {
  return typeof roomId === 'string' && ROOM_ID_PATTERN.test(roomId);
}

/** @returns {'paint'|'chart'|null} */
export function canvasKindOf(roomId) {
  return isValidRoomId(roomId) ? roomId.split('-')[0] : null;
}

/** Link another device opens to join the room — works from any page. */
export function liveLinkFor(roomId) {
  return `${window.location.origin}/live/${roomId}`;
}
